import { createSlice } from "@reduxjs/toolkit";
const profileSlice = createSlice({
  name: "profile",
  initialState: {
    rankDetails: null,
  },
  reducers: {
    setRankDetails(state, action) {
      state.rankDetails = action.payload;
    }
  },
});

export const { clearProfile, setRankDetails } = profileSlice.actions;
export default profileSlice.reducer;
